import { useState, type ReactNode } from 'react';
import { useI18n } from '../i18n';
import { Button } from './ui';

/**
 * Confirmation pour les actions aux conséquences non évidentes.
 *
 * Le texte explique systématiquement ce qui va se passer pour les autres — libérer les
 * licences de l'équipe, poser un délai de 24 h — plutôt que de demander « êtes-vous
 * sûr ? », qui n'informe personne.
 */
export function ConfirmButton({
  message,
  onConfirm,
  children,
  variant = 'danger',
  pending,
}: {
  message: string;
  onConfirm: () => void;
  children: ReactNode;
  variant?: 'primary' | 'ghost' | 'danger';
  pending?: boolean;
}) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  if (!open) {
    return (
      <Button variant={variant} onClick={() => setOpen(true)} pending={pending}>
        {children}
      </Button>
    );
  }

  return (
    <div className="confirm">
      <p>{message}</p>
      <div className="row">
        <Button
          variant={variant}
          pending={pending}
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
        >
          {t('common.confirm')}
        </Button>
        <Button onClick={() => setOpen(false)}>{t('common.cancel')}</Button>
      </div>
    </div>
  );
}
